if (!customElements.get("pickup-availability")) {
  customElements.define(
    "pickup-availability",
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute("available")) return;

        this.errorHtml =
          this.querySelector("template").content.firstElementChild.cloneNode(
            true,
          );
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        const root = window?.Shopify?.routes?.root || "/";
        const variantSectionUrl = `${root}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl, { credentials: "same-origin" })
          .then((response) => {
            if (!response.ok)
              throw new Error(`Pickup request failed: ${response.status}`);
            return response.text();
          })
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, "text/html")
              .querySelector(".shopify-section");
            this.renderPreview(sectionInnerHTML);
          })
          .catch(() => {
            const button = this.querySelector("button");
            if (button)
              button.removeEventListener("click", this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      renderError() {
        this.innerHTML = "";
        this.appendChild(this.errorHtml);

        this.querySelector("button").addEventListener(
          "click",
          this.onClickRefreshList,
        );
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector("pickup-availability-drawer");
        if (drawer) drawer.remove();
        if (
          !sectionInnerHTML ||
          !sectionInnerHTML.querySelector("pickup-availability-preview")
        ) {
          this.innerHTML = "";
          this.removeAttribute("available");
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector(
          "pickup-availability-preview",
        ).outerHTML;
        this.setAttribute("available", "");

        const drawerContent = sectionInnerHTML.querySelector(
          "pickup-availability-drawer",
        );
        if (drawerContent) document.body.appendChild(drawerContent);

        const triggerButton = this.querySelector("button");
        if (triggerButton) {
          triggerButton.addEventListener("click", (evt) => {
            const availabilityDrawer = document.querySelector(
              "pickup-availability-drawer",
            );
            if (availabilityDrawer) availabilityDrawer.show(evt.target);
          });
        }
      }
    },
  );
}

if (!customElements.get("pickup-availability-drawer")) {
  customElements.define(
    "pickup-availability-drawer",
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector("button").addEventListener("click", () => {
          this.hide();
        });

        this.addEventListener("keyup", (event) => {
          if (event.code?.toUpperCase() === "ESCAPE") this.hide();
        });
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (
          target != this &&
          !target.closest("pickup-availability-drawer") &&
          target.id != "ShowPickupAvailabilityDrawer"
        ) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute("open");
        document.body.removeEventListener("click", this.onBodyClick);
        document.body.classList.remove("overflow-hidden");
        removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute("open", "");
        document.body.addEventListener("click", this.onBodyClick);
        document.body.classList.add("overflow-hidden");
        trapFocus(this);
      }
    },
  );
}
